<template>
  <b-modal
    id="reset-password-modal"
    title="RESET PASSWORD"
    hide-footer
    centered
    size="sm"
    dialog-class="reset-modal-dialog"
    content-class="reset-modal-content"
  >
    <h5 class="text-center">Reset Password</h5>

    <p class="text-center text-muted">
      This will immediately reset the user's password. A temporary password will
      be sent to their email.
    </p>

    <!-- Input -->
    <b-form-group label="Email Address *" label-class="font-weight-bold">
      <b-form-input
        v-model="email"
        disabled
        type="email"
        placeholder="Enter user email"
      ></b-form-input>
    </b-form-group>

    <div class="mt-2">
      <b-button block variant="secondary" @click="closeModal">
        CANCEL
      </b-button>

      <b-button block variant="danger" @click="onSubmit">
        RESET PASSWORD
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { BButton, BModal, BFormGroup, BFormInput } from "bootstrap-vue";
import { stringProp } from "@/helpers/props";
import { mapActions } from "vuex";
export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
  },
  props: {
    email: stringProp(),
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions("user/detail", ["resetPassword"]),
    closeModal() {
      this.$bvModal.hide("reset-password-modal");
    },
    async onSubmit() {
      const result = await this.resetPassword({
        userId: this.$route.params.id,
      });
      if (result) this.closeModal();
    },
  },
};
</script>
